export default __webpack_public_path__ + "static/media/product-1.57343160.JPG";